import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import en from '../../../international/translations/en';
import { connect } from 'react-redux';
import { renew } from '../../../redux/Account/overview';
import {
  UserCard, PromoCard,
  StatusError, SubscriptionSummaryCard, FailedPaymentMessage,
} from 'components';

class Overview extends Component {
  static propTypes = {
    user: PropTypes.object,
    overview: PropTypes.object,
    subscription: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.analytics.page('Account', 'Overview');
  }

  /**
   * Used for one-click renewals of expiring subscriptions.
  */
  renewSubscriptionHandler = (planId) => {
    this.props.dispatch(renew(planId));

    window.analytics.track(
      'Clicked Renew Subscription',
      {
        location: 'account-overview',
        plan: planId
      }
    );
  }


  render() {
    const { subscription, overview } = this.props;
    const { companyMap, subscriptions } = subscription;

    return (
      <div className="overview__container">
        <Helmet title={en.account.overview.meta_title} />

        {(() => {
          if (overview.isRenewingError) {
            return (
              <StatusError statusErrorMessage={overview.renewalErrorMessage} />
            );
          }
        })()}

        {(() => (
          companyMap.map(brand => subscriptions[brand].map((sub) => {
            if (sub.failedPaymentAttempts > 0) {
              return (
                <FailedPaymentMessage
                  subscription={sub}
                  key={sub.subscriptionId}
                  brand={brand}
                />
              );
            }
          }))
        ))()}

        <div className="overview__three__column">
          <UserCard user={this.props.user} />
          <SubscriptionSummaryCard subscription={subscription} companyMap={companyMap} overview={overview} renewHandler={this.renewSubscriptionHandler} />
        </div>

        <div className="overview__nine__column">
          <PromoCard
            overview={overview}
            renewHandler={this.renewSubscriptionHandler}
            subscription={subscription}
            companyMap={companyMap}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.user,
  overview: state.overview,
  subscription: state.subscription,
}))(Overview);
